import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import {
  ConsultationActivity,
  DashboardQueryProps,
} from "@customTypes/dashboard";
import { Pagination } from "@customTypes/index";

import { dashboardQKeys } from "./queryKeys";


const select = (res: any) => {
  //   console.log(res.data);
  const pagination: Pagination = {
    page: res.data.pagination.page,
    pageCount: res.data.pagination.page_count,
    pageSize: res.data.pagination.page_size,
    total: res.data.pagination.total,
  };

  const newData = [] as ConsultationActivity[];

  if (res.data.data.length) {
    for (const i in res.data.data) {
      const {
        consultation_date,
        _id,
        patient_id,
        c_id,
        report_status,
        billing_status,
        consultation_type,
        physician,
        consultation_service,
      } = res.data.data[i];
      newData.push({
        id: _id,
        patientId: patient_id,
        cId: c_id,
        reportStatus: report_status,
        billingStatus: billing_status,
        type: consultation_type,
        physician,
        service: consultation_service,
        date: new Date(consultation_date),
      });
    }

    return { newData, pagination };
  }

  return null;
};

export const useGetConsultationActivity = ({
  dateRange,
  startDate,
  endDate,
  userId,
  pagination,
}: DashboardQueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: dashboardQKeys.consultationActivityWithFilters({
      dateRange,
      startDate,
      endDate,
      userId,
      pagination, // Add pagination to the query key
    }),
    queryFn: () => {
      return api.get("analytics/consultations/activity", {
        params: {
          range: dateRange?.replaceAll("-", "_"),
          ...(dateRange === "custom" && {
            start_date: startDate,
            end_date: endDate,
          }),
          ...(userId && {
            physician: userId,
          }),
          page: pagination?.page,
          page_size: pagination?.pageSize,
        },
      });
    },
    select,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled:
      dateRange !== "custom" ||
      !!(dateRange === "custom" && startDate && endDate),

    onError: (res: any) => {
      console.error("[From Get Consultation activity]", res);
      handleErrors(res, "query");
    },
  });
};
